
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TeamModel } from './Identity.Api.Models.Team';
import { DashboardElementModel } from './Identity.Api.Models.DashboardElement';
import { Model, ModelProperty } from 'models/Model';


export class TeamDashboardElementModel extends Model<TeamDashboardElementModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'teamId', type: 'guid', languageString: 'teamDashboardElement.property.teamId' },
		{ name: 'team', type: 'TeamModel', languageString: 'teamDashboardElement.property.team', isHidden: true, isObject: true, new: () => { return new TeamModel }, properties: () => { return TeamModel.classProperties } },
		{ name: 'dashboardElementId', type: 'guid', languageString: 'teamDashboardElement.property.dashboardElementId' },
		{ name: 'dashboardElement', type: 'DashboardElementModel', languageString: 'teamDashboardElement.property.dashboardElement', isHidden: true, isObject: true, new: () => { return new DashboardElementModel }, properties: () => { return DashboardElementModel.classProperties } },
		{ name: 'sortOrder', type: 'number', languageString: 'teamDashboardElement.property.sortOrder' }
	];
	[key: string]: any;
	
	public teamId?: string;
	public team?: TeamModel;
	public dashboardElementId?: string;
	public dashboardElement?: DashboardElementModel;
	public sortOrder?: number;
    
	constructor(){
		super();
		this.teamId = undefined;
		this.team = undefined;
		this.dashboardElementId = undefined;
		this.dashboardElement = undefined;
		this.sortOrder = undefined;
		
	}
	getProperties(){
		return TeamDashboardElementModel.classProperties;
	}
}

